import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import styled from 'styled-components';
import { Title } from '~/styles/layoutElements';
import { HelpModal } from './HelpModal';

export interface TitleWithQuestionProps {
  title: string;
  className?: string;
  /** Optional stable key used to pre-select the help section. Defaults to title. */
  helpKey?: string;
}

export function TitleWithQuestion({
  title,
  className,
  helpKey,
}: TitleWithQuestionProps) {
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  return (
    <>
      <TitleContainer className={className}>
        <Title>{title}</Title>
        <QuestionIcon
          icon={faCircleQuestion}
          onClick={() => setIsHelpOpen(true)}
        />
      </TitleContainer>
      <HelpModal
        isOpen={isHelpOpen}
        onClose={() => setIsHelpOpen(false)}
        helpKey={helpKey ?? title}
      />
    </>
  );
}

const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;

const QuestionIcon = styled(FontAwesomeIcon)`
  color: var(--wbs-red);
  cursor: pointer;
  font-size: 20px;
  transition: opacity 0.15s ease;
`;
